import { PHOTO_TYPE, QUESTION_TYPE, TRIP_QUESTION_SECTION } from 'types'

const {
  CHECK_IN_STANDARD,
  CHECK_IN_CUSTOM,
  CHECK_OUT_STANDARD,
  CHECK_OUT_CUSTOM,
} = TRIP_QUESTION_SECTION

const CHECK_IN_STANDARD_PHOTO_TYPES = new Set([
  PHOTO_TYPE.SERIAL_NUMBER,
  PHOTO_TYPE.MACHINE_STATE,
])

const CHECK_OUT_STANDARD_PHOTO_TYPES = new Set([
  PHOTO_TYPE.UNIT_CONDITION,
  PHOTO_TYPE.WORK_PERFORMED,
  PHOTO_TYPE.ABUSE,
  PHOTO_TYPE.DEFECT,
])

function firstPhotoType(question) {
  const response = question?.questionResponse
  if (!Array.isArray(response) || response.length === 0) return undefined
  return response[0].photoType
}

// Older payloads omit `section`. Standard photos can still be bucketed from
// photoType; custom text/photos without a section default to check-in custom.
export function inferTripQuestionSection(question) {
  if (question?.section) return question.section
  if (question?.type === QUESTION_TYPE.PHOTO) {
    const photoType = firstPhotoType(question)
    if (CHECK_IN_STANDARD_PHOTO_TYPES.has(photoType)) return CHECK_IN_STANDARD
    if (CHECK_OUT_STANDARD_PHOTO_TYPES.has(photoType)) return CHECK_OUT_STANDARD
    if (photoType === PHOTO_TYPE.CUSTOM) return CHECK_IN_CUSTOM
    return CHECK_OUT_STANDARD
  }
  return CHECK_IN_CUSTOM
}

export default function groupTripQuestionResponses(questions = []) {
  return questions.reduce(
    (groups, question) => {
      const section = inferTripQuestionSection(question)
      if (groups[section]) groups[section].push(question)
      else groups[CHECK_IN_CUSTOM].push(question)
      return groups
    },
    {
      [CHECK_IN_STANDARD]: [],
      [CHECK_IN_CUSTOM]: [],
      [CHECK_OUT_STANDARD]: [],
      [CHECK_OUT_CUSTOM]: [],
    }
  )
}
